import { supabase } from "@/platform/lib/supabase";
import type { UspCurso } from "@/tenants/usp/lib/nota-projetada-fuvest";

export interface UspProfile {
  user_id: string;
  curso_alvo: UspCurso;
  exam_date_fase1: string | null;
  exam_date_fase2_dia1: string | null;
  exam_date_fase2_dia2: string | null;
  weekly_hours: number;
  treineira: boolean;
  onboarding_completed: boolean;
}

export interface UspOnboardingValues {
  curso_alvo: UspCurso;
  exam_date_fase1: string;
  exam_date_fase2_dia1: string;
  exam_date_fase2_dia2: string;
  weekly_hours: number;
  treineira: boolean;
}

export async function fetchUspProfile(userId: string): Promise<UspProfile | null> {
  const { data, error } = await supabase
    .from("usp_profiles")
    .select()
    .eq("user_id", userId)
    .maybeSingle();
  if (error) throw error;
  return (data as UspProfile | null) ?? null;
}

export async function completeUspOnboarding(
  userId: string,
  values: UspOnboardingValues,
): Promise<void> {
  const { error } = await supabase.from("usp_profiles").upsert(
    {
      user_id: userId,
      curso_alvo: values.curso_alvo,
      exam_date_fase1: values.exam_date_fase1,
      exam_date_fase2_dia1: values.exam_date_fase2_dia1,
      exam_date_fase2_dia2: values.exam_date_fase2_dia2,
      weekly_hours: values.weekly_hours,
      treineira: values.treineira,
      onboarding_completed: true,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "user_id" },
  );
  if (error) throw error;
}
